<template>
  <el-dialog
    :title="`${model.type == 1 ? '知识库' : '市场活动'}详情`"
    :visible.sync="visible"
    width="650px"
    @close="$emit('update:show', false)"
    top="5vh"
  >
    <el-descriptions
      title=""
      size="small"
      :column="1"
      border
      :labelStyle="{ width: '100px' }"
    >
      <el-descriptions-item label="名称">{{
        model.title
      }}</el-descriptions-item>
      <el-descriptions-item label="是否公开" v-if="model.type == 1">{{
        model.is_public == 2 ? '否' : '是'
      }}</el-descriptions-item>
      <el-descriptions-item label="有效期">{{
        model.start_date ? `${model.start_date} 至 ${model.end_date}` : '无'
      }}</el-descriptions-item>
      <el-descriptions-item label="设备分类">
        <div style="display: flex; flex-wrap: wrap; gap: 5px">
          <el-tag
            type="info"
            size="mini"
            v-for="item in model.item_category_names"
            :key="item"
            >{{ item.replace(/,/g, '-') }}</el-tag
          >
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="正文形式">{{
        model.content_type == 1 ? '网页链接' : '自定义'
      }}</el-descriptions-item>
      <el-descriptions-item label="正文详情">
        <el-link
          v-if="model.content_type == 1"
          :href="model.content"
          target="_blank"
          type="primary"
          :underline="false"
          >{{ model.content }}</el-link
        >
        <div v-else class="commodity-content" v-html="model.content"></div>
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>
<script>
export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      visible: false,
    }
  },
}
</script>

<style scoped>
.commodity-content {
  max-height: 50vh;
  overflow-y: auto;
  word-break: break-all;
}

/deep/.commodity-content img {
  width: 100%;
}

/deep/.commodity-content p {
  margin-bottom: 0;
}
</style>